// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"351":"ad9a7950c762ca32d4cf","532":"2a73a1ef87a039ecd42f","678":"40061be12577e0ba7c6a","883":"acd5c69c676a508c104a"}[chunkId] + ".js";
};